import { HistogramBin } from '../../../types/histogram.js';

export const isBinWithinRange = (bin: HistogramBin, from: number, to: number) =>
  bin.from <= to && bin.to >= from;
